export enum TITLE {
	Madam = 1,
	Mister = 2,
}
